import { useIntl } from 'react-intl';
import DppModal from './DppModal';
import WaterMeterReadingsForm from '../forms/WaterMeterReadingsForm';

const WaterMeterReadingsModal = ({ show, onSave, onClose }) => {
  const intl = useIntl();
  const modalTitle = intl.formatMessage({ id: 'action_add_watermeter_readings' });

  const handleSave = (data) => {
    onSave?.(data);
    onClose();
  };

  const footerButtons = (
    <></>
  );

  return (
    <DppModal
      show={show}
      handleClose={onClose}
      title={modalTitle}
      footerButtons={footerButtons}
      size="lg"
      centered
    >
      <WaterMeterReadingsForm
        onSave={handleSave}
        onCancel={onClose}
        isModal={true}
      />
    </DppModal>
  );
};

export default WaterMeterReadingsModal;